"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (process.env.NODE_ENV !== "production" || typeof gtag !== "function") {
    return null;
  }

  var pathIsExcluded = location && typeof window.excludeGtagPaths !== "undefined" && window.excludeGtagPaths.some(function (rx) {
    return rx.test(location.pathname);
  });
  if (pathIsExcluded) return null;
  var pagePath = location ? location.pathname + location.search + location.hash : undefined;
  window.gtag("event", "page_view", {
    page_path: pagePath
  });
  return null;
};